import React from 'react';
import SchoolIcon from '@mui/icons-material/School';
import AttorneyIcon from './attorney-icon';
import ShieldCheckIcon from './shield-check-icon';

const PersonIcon = ({ role }) => {
  const roleLower = (role || '').toLowerCase();
  
  if (roleLower.includes('learner')) {
    return <SchoolIcon style={{ color: '#0096CA', width: 16, height: 16 }} />;
  } else if (roleLower.includes('attorney')) {
    return <AttorneyIcon size={16} fill="#55458E" />;
  } else {
    return <ShieldCheckIcon size={16} fill="#0F48B8" />;
  }
};

export default PersonIcon;

